<template>
  <div class="from-main">
    <v-container
      fill-height
      fluid
      grid-list-md
      class="text-xs-left"
      style="min-height:730px; max-width: 1240px; "
    >
      <v-layout
        row
        wrap
        align-center
        class="text-xs-left"
        :style="{ maxWidth: '1240px' }"
      >
        <v-flex md5>
          <div class="text-xs-left my-4">
            <div class="top-gsmg">
              <img :src="'/img/front_top_gsmg.svg'" alt="GSMG" />
            </div>
            <div class="top-title-1">Get access to advanced crypto market insights</div>
            <div class="top-title-2">Buy and sell suggestions powered by GSMG</div>
            <div style="margin-top: 60px;">
              <v-btn flat to="/register" class="top-get-started"
                >Get started</v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return { title: this.$t("home") };
  },
  data: () => ({
    title: window.config.appName
  }),
  methods: {
    downloadFaq() {
      const url = "/faq.pdf";
      window.open(url, "_blank");
    },
    openHelpCenter() {
      const url = "https://intercom.help/gsmg";
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
  margin-top: 24px;
}

.argument {
  align-self: start;
  text-align: left;
  display: flex;
  align-items: start;
}

.argument > div {
  margin-left: 10px;
}

.argument .title {
  line-height: 34px !important;
}
.from-main {
  background-image: url("/img/front_bg_insights_1920.svg");
  background-repeat: no-repeat;
  background-position: right top;
  background-color: #f2f7ff;
}
.price-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
.price-description {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #103a84;
}
.supported-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
.exchanged-box {
  border-top: solid 2px #d1e2ff;
  border-bottom: solid 2px #d1e2ff;
}
.info-container {
  background: #f2f7ff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 30px;
}
.info-box {
  margin: 32px 12px !important;
}
.box-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: rgba(16, 58, 132, 0.7);
  margin-top: 16px;
}
.box-height {
  min-height: 220px;
}
.top-gsmg {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.1em;
  color: #103a84;
}
.top-title-1 {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: 300;
  font-size: 26px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #103a84;
}
.top-title-2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 140%;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #103a84;
  margin-top: 16px;
}
.top-get-started {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  padding: 10px 25px 10px 25px;
  text-decoration: none;
  width: 200px;
  height: 50px;
}
.px-32 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
@media (max-width: 1919px) {
  .from-main {
    background-image: url("/img/front_bg_insights.svg");
  }
}
@media (max-width: 960px) {
  .from-main {
    background-image: none;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/insights/welcome.vue